import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_PROGRAM_ORDER_CLEANUP_ALL_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_PROGRAM_ORDER_CLEANUP_ALL_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_PROGRAM_ORDER_CLEANUP_ALL_API_ID,
  ({ payload }) => ({
    endpoint: `/api/admin/program-orders/cleanup-all`,
    method: 'POST',
    body: payload,
    notify: true,
  })
);

export default apiCall;
